import { AlertProps } from '@mui/material/Alert'
import { AlertTitle, Alert as MuiAlert, AlertProps as MuiAlertProps } from '@mui/material'
import { ReactNode, forwardRef } from 'react'

export const Alert = forwardRef<HTMLDivElement, AlertProps>(
  ({ title, description, children, ...rest }, ref) => {
    return (
      <MuiAlert ref={ref} {...rest}>
        {title && <AlertTitle>{title}</AlertTitle>}
        {description}
        {children}
      </MuiAlert>
    )
  }
)
Alert.displayName = 'Alert'

declare module '@mui/material/Alert' {
  interface AlertPropsVariantOverrides {
    filled: false
  }

  interface AlertProps
    extends Pick<MuiAlertProps, 'title' | 'severity' | 'icon' | 'action' | 'onClose'> {
    description?: ReactNode | string
  }
}
